import { KeySystem } from '../../enums/key_system';
export const KeySystemSetting = {
    [KeySystem.WIDEVINE]: {
        commonName: 'widevine',
        licenseServer: 'https://@webgate/widevine-license',
        withCertificate: true,
        pssh_field: {
            audio: 'pssh_widevine',
            video: 'encryption_data',
        },
    },
    [KeySystem.PLAYREADY]: {
        commonName: 'playready',
        licenseServer: 'https://@webgate/playready-license',
        withCertificate: false,
        pssh_field: {
            audio: 'pssh_playready',
            video: 'encryption_data',
        },
    },
    [KeySystem.PLAYREADY_HARDWARE]: {
        commonName: 'playready',
        licenseServer: 'https://@webgate/playready-license',
        withCertificate: false,
        pssh_field: {
            audio: 'pssh_playready',
            video: 'encryption_data',
        },
    },
    [KeySystem.FAIRPLAY]: {
        commonName: 'fairplay',
        licenseServer: 'https://@webgate/fairplay-license',
        withCertificate: true,
        pssh_field: {
            audio: 'pssh_fairplay',
            video: 'asset_id',
        },
    },
    [KeySystem.INVALID_SPOTIFY_KEY]: {
        commonName: 'spotify-invalid',
        licenseServer: 'https://@webgate',
        withCertificate: false,
        pssh_field: {
            audio: 'pssh_invalid',
            video: 'encryption_data',
        },
    },
};
//# sourceMappingURL=keysystem_setting.js.map